import React from 'react'
import './App.css'
import Footer from './Footer';
import Topbar from './Topbar';

export default function Contact() {
    return (
      <div>
        <Topbar />        
        <div className="bg-white">
            <div className="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
            <div className="mx-auto max-w-2xl text-center">
                <h2 className="text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl">
                Contact Us
                <br />
                We are happy you are here!
                </h2>
                <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-600">
                Connect, schedule time, or drop us a line.
                <br/>
                We are a product focused community 
                <br/>
                of creators, developers, and designers.

                </p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                <a href="/connectcontact" className="rounded-md bg-gray-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                    Connect <span aria-hidden="true"></span>
                </a>
                    {/* href open a new tab */}
                

                <a
                    href="https://calendly.com/ryan-binaryinventions" target="_blank" rel="noreferrer"
                    className="rounded-md bg-gray-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                    Schedule
                </a>
                <a href="/servicerequest" className="rounded-md bg-gray-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                    Services <span aria-hidden="true"></span>
                </a>
                </div>
            </div>
            </div>
        </div>
        <Footer />
      </div>
    )
  }